import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckIcon from 'components/Highlights/images/small-check.svg';

const useStyles = makeStyles({
  linkIcon: {
    width: 12,
    marginRight: 12,
  },
  linkItem: {
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '18px',
  },
});

const HighlightEntry = ({ value }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.linkItem} color="textPrimary">
      <img src={CheckIcon} className={classes.linkIcon} alt="" />
      {value}
    </Typography>
  );
};

HighlightEntry.propTypes = {
  value: PropTypes.string,
};

export default HighlightEntry;
